module.exports = __webpack_public_path__ + "img/mount-mask.e0826ee0.png";